"use strict";

exports.__esModule = true;
exports.PerformanceParameterValueElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceDataItemSubscription = require("../../Device/DeviceDataItemSubscription");
var _MeasurementValue = require("../../Measures/MeasurementValue");
var _Utils = require("../../../Utils");
var _common = require("../common");
var _Device = require("../../Device");
var _dec, _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a particular realtime performance parameter value for a device.
 */
var PerformanceParameterValueElement = exports.PerformanceParameterValueElement = (_dec = _DeviceContext.DeviceContext.withContext, _dec(_class = /*#__PURE__*/function (_Component) {
  function PerformanceParameterValueElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(PerformanceParameterValueElement, _Component);
  var _proto = PerformanceParameterValueElement.prototype;
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      device = _this$props.device,
      dataItemIndex = _this$props.dataItemIndex,
      backgroundColorSource = _this$props.backgroundColorSource;
    var realtimeDataItems = device.performanceParameters.realtimeDataItems;
    if (realtimeDataItems.length <= dataItemIndex) {
      if (backgroundColorSource) {
        return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
          deviceUuid: device.uuid
        }, (0, _common.getWidgetColorProps)(this.props)), function (colors) {
          return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, (0, _common.getWidgetPositionProps)(_this.props), (0, _common.getWidgetInteractionProps)(_this.props)), colors.backgroundColor && /*#__PURE__*/_react["default"].createElement("rect", {
            x: 0,
            y: 0,
            width: _this.props.width,
            height: _this.props.height,
            fill: colors.backgroundColor
          }));
        });
      }
      return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, (0, _common.getWidgetPositionProps)(this.props), (0, _common.getWidgetInteractionProps)(this.props)));
    }
    if (backgroundColorSource) {
      return this.renderSubscription();
    }
    return this.renderSubscription();
  };
  _proto.renderSubscription = function renderSubscription() {
    var _this2 = this;
    var _this$props2 = this.props,
      device = _this$props2.device,
      dataItemIndex = _this$props2.dataItemIndex,
      hideLabel = _this$props2.hideLabel,
      hideMtcAgentUnits = _this$props2.hideMtcAgentUnits,
      decimalPlaces = _this$props2.decimalPlaces;
    var realtimeDataItems = device.performanceParameters.realtimeDataItems;
    var dataItem = realtimeDataItems[dataItemIndex];
    return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemSubscription.DeviceDataItemSubscription, {
      deviceUuid: device.uuid,
      dataItem: dataItem
    }, function (packet) {
      return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
        deviceUuid: device.uuid
      }, (0, _common.getWidgetColorProps)(_this2.props), {
        value: packet && packet.value || ""
      }), function (_ref) {
        var color = _ref.color,
          backgroundColor = _ref.backgroundColor;
        var value = packet && packet.value;
        if (typeof value === "number" && !Number.isInteger(packet.value) && decimalPlaces) {
          value = new Number(packet.value).toFixed(decimalPlaces);
        }
        return /*#__PURE__*/_react["default"].createElement(_MeasurementValue.MeasurementValue, _extends({
          value: value,
          units: dataItem.units || "",
          label: !hideLabel && (0, _Utils.humanizeString)(dataItem.name || ""),
          color: color,
          backgroundColor: backgroundColor,
          hideMtcAgentUnits: hideMtcAgentUnits
        }, (0, _common.getWidgetPositionProps)(_this2.props), (0, _common.getWidgetFontProps)(_this2.props), (0, _common.getWidgetInteractionProps)(_this2.props)));
      });
    });
  };
  return PerformanceParameterValueElement;
}(_react.Component)) || _class);